'use client';

import { useTranslations } from 'next-intl';
import { usePathname, useSearchParams } from 'next/navigation';
import { useTransition, useRef, useEffect } from 'react';
import { selectDefaultStore } from 'services/dealer-locator/actions';
import LoaderWithOverlay from '../../../account/(with-nav)/control-center/common/LoaderWithOverlay';

export const DefaultStoreSelector = () => {
  const [isPending, startTransition] = useTransition();
  const hasErrorRef = useRef(false);
  const t = useTranslations();

  /*  TODO - Input Validations - useSearchParams: The search param object should contain key value pairs where
      the value is of string type, not including reservered url special / unsafe characters like / \ & ? = : % + ' " ; < > { } [ ] @ #
      */
  const queryParams = useSearchParams();

  /* TODO - Input Validations - usePathName: pathName is not in use in
      selectDefaultStore. This hook can be deleted*/
  const pathname = usePathname();
  const hasQueryParams = !!queryParams.size;
  const allParams = queryParams.toString();

  useEffect(() => {
    if (hasErrorRef.current) {
      return;
    }

    startTransition(async () => {
      try {
        await selectDefaultStore(hasQueryParams, pathname, allParams);
      } catch (error) {
        // Mark as error to prevent any further attempts
        hasErrorRef.current = true;
      }
    });
  }, [allParams, hasQueryParams, pathname]);

  if (hasErrorRef.current) {
    return null;
  }

  return isPending ? (
    <LoaderWithOverlay
      message={t('SALESFORCE_CHAT_LOADING_TEXT')}
      cardClassName="px-2 py-2 align-items-center cat-u-theme-typography-label"
      messageClassName="ps-2"
    />
  ) : null;
};
